import React, {Component} from 'react';
import {Header} from '../Header';
import {Footer} from '../Footer';
import {Helmet} from "react-helmet";

export class AccessibilityNO extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Tilgjengelighetserklæring - CamAPS FX</title>
                    <meta name="title" content="Tilgjengelighetserklæring"/>
                    <meta name="description"
                          content="CamDiab er forpliktet til å legge til rette for og forbedre tilgjengeligheten og brukervennligheten til sine digitale produkter for alle mennesker, inkludert pe"/>
                    <meta property="og:locale" content="nb"/>
                    <meta name="keywords" content="tilgjengelighetserklæring"/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Tilgjengelighetserklæring</h1>
                                <h3>Versjon datert 11. september 2026</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <p>
                                    CamDiab er forpliktet til å legge til rette for og forbedre tilgjengeligheten og brukervennligheten til sine digitale produkter for alle mennesker, inkludert personer med funksjonsnedsettelser.
                                </p>
                                <h2>
                                    Samsvarsstatus
                                </h2>
                                <p>
                                    CamDiab har som mål å oppnå samsvar med Retningslinjer for tilgjengelig webinnhold (WCAG) versjon 2.2, nivå AA (WCAG 2.2 AA). Disse globalt anerkjente retningslinjene bidrar til å gjøre webinnhold mer tilgjengelig for alle.
                                </p>
                                <h2>
                                    Ytterligere tiltak for å støtte tilgjengelighet
                                </h2>
                                <p>
                                    CamDiab gjennomfører blant annet følgende ytterligere tiltak for å gjøre det digitale innholdet vårt enklere å bruke:
                                </p>
                                <ul>
                                    <li>Tilby kontinuerlig opplæring i tilgjengelighet for våre ansatte</li>
                                    <li>Benytte formelle metoder for kvalitetssikring av tilgjengelighet gjennom vurderinger fra tredjeparter</li>
                                    <li>Fastsette tydelige mål og ansvarsområder for tilgjengelighet</li>
                                </ul>
                                <h2>
                                    Tilbakemelding
                                </h2>
                                <p>
                                    Vi tar gjerne imot kommentarer om hvordan vi kan forbedre våre digitale produkter for brukere med funksjonsnedsettelser. Hvis du har problemer med å se eller navigere i innholdet vårt, eller oppdager innhold, funksjoner eller funksjonalitet som du mener ikke er fullt tilgjengelig for personer med funksjonsnedsettelser, kan du kontakte oss via vår e-postadresse for kundestøtte: <a href="mailto:support@camdiab.com">support@camdiab.com</a>
                                </p>
                                <p>
                                    Vi tar tilbakemeldingene dine på alvor og vil ta dem med i vurderingen når vi ser på hvordan vi kan imøtekomme alle kundene våre og utvikle våre overordnede retningslinjer for tilgjengelighet. Selv om vi ikke har kontroll over innhold som leveres av tredjepartsleverandører, oppfordrer vi dem på det sterkeste til å tilby innhold som er tilgjengelig og brukervennlig.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
